import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import DataWrapper from '../../principal/containers/DataWrapper';
import {Row, Col, FormGroup, Label, Input} from 'reactstrap';
import {TabelaCadastro} from "../components/TabelaCadastro";
import {Validacao} from "../../comum/components/Validacao";
import LotacaoStore from "../stores/LotacaoStore";
import Select from 'react-select'
import NumberFormat from "react-number-format";

@inject("store")
@DataWrapper
@observer
export class CadastroLotacao extends Component {
    constructor(props) {
        super(props);
        this.modal = this.props.store.modalStore;
        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        /* Selecionar Controller */
        this.controller = new LotacaoStore(this.modal);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Lotação");
        this.controller.carregarLista();
    }

    modalForm = () => {
        return(
            <Row>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Nome <sup>*</sup></Label>
                        <Input type="text" maxLength={64} value={this.controller.itemSelecionado.nome} onChange={(event) => this.controller.setNome(event.target.value)}/>
                        <Validacao id="nome" valor={this.controller.itemSelecionado.nome} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Ativo <sup>*</sup></Label>
                        <Input type="text" maxLength={64} value={this.controller.itemSelecionado.ativo} disabled={true} />
                        <Validacao id="ativo" valor={this.controller.itemSelecionado.ativo} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>CNPJ <sup>*</sup></Label>
                        <Input type="text" maxLength={64} value={this.controller.itemSelecionado.cnpj} disabled={true} />
                        <Validacao id="cnpj" valor={this.controller.itemSelecionado.cnpj} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Unidade de negócio (BU) <sup>*</sup></Label>
                        <Select type="text" maxLength={4} options={this.controller.opcoesEmpresaGlobo} value={this.controller.itemSelecionado.empresaGloboId} onChange={(event) => this.controller.setEmpresaGloboId(event)} />
                        <Validacao id="empresaGloboId" valor={this.controller.itemSelecionado.empresaGloboId} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Valor de VR p/ cálculo de custo de MOT <sup>*</sup></Label>
                        <NumberFormat suffix="" allowNegative={false} className="form-control" decimalPrecision={2} value={this.controller.itemSelecionado.valorCustoVRMot} onChange={(event, values) => this.controller.setValorCustoVRMot(values.floatValue)}/>
                        <Validacao id="valorCustoVRMot" valor={this.controller.itemSelecionado.valorCustoVRMot} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
            </Row>
        )
    };

    obterTituloMobile = (objeto) => {
        return objeto.nome;
    };

    obterConteudoMobile = (objeto) => {
        return (
            <div>
                { "Ativo: " + objeto.ativo}<br/>
                { "Unidade de negócio (BU): " + objeto.nomeEmpresaGlobo}<br/>
            </div>
        )
    };

    render() {
        /* Colunas da TabelaStore */
        const colunas = [
            {
                field: "nome",
                label: "Nome"
            },
            {
                field: "ativo",
                label: "Ativo"
            },
            {
                field: "cnpj",
                label: "CNPJ"
            },
            {
                field: "nomeEmpresaGlobo",
                label: "Unidade de negócio (BU)"
            },
            {
                field: "valorCustoVRMot",
                label: "Valor VR p/ Custo de Mot ",
                //type: "percentage"
            }
            //RHFPP-1548 - Consulta Custo Mot
        ];

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel panel-sm" : "panel-sm"}>
                        <TabelaCadastro
                            nomeCadastro={'Lotação'}
                            onChange={(value) => this.controller.setLista(value)}
                            listaItens={this.controller.lotacaoLista}
                            colunas={colunas}
                            temBusca={true}
                            criarNovos={false}
                            modalEditar={this.modalForm()}
                            preencherModal={(row) => this.controller.preencherModal(row)}
                            editar={() => this.controller.editar()}
                            tituloMobile={(row) => this.obterTituloMobile(row)}
                            conteudoMobile={(row) => this.obterConteudoMobile(row)}
                            loading={this.controller.loading}
                        />
                    </div>
                </div>
            </div>
        );
    }
}